import { render, staticRenderFns } from "./page-header-BI.vue?vue&type=template&id=690f3bad&scoped=true"
import script from "./page-header-BI.vue?vue&type=script&lang=js"
export * from "./page-header-BI.vue?vue&type=script&lang=js"
import style0 from "./page-header-BI.vue?vue&type=style&index=0&id=690f3bad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690f3bad",
  null
  
)

export default component.exports